import { Error } from './Error';

export default class ValidationResult {
	public readonly countryErrors: Error[];

	public readonly productErrors: Error[];

	public readonly referencePackageSizeIsMissing: boolean;

	public constructor(referencePackageSizeIsMissing: boolean, productErrors: Error[], countryErrors: Error[]) {
		this.referencePackageSizeIsMissing = referencePackageSizeIsMissing;
		this.productErrors = productErrors;
		this.countryErrors = countryErrors;
	}
}
